import lainnya from "./lainnya.svg";
import cashback from "./cashback.svg";
export default {
  lainnya,
  cashback,
};
